var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"levo__dole__leave"},[_c('div',{staticClass:"pointer",on:{"click":function($event){return _vm.$emit('leave')}}},[_vm._m(0),_c('div',{staticClass:"levo__dole__leave__text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"levo__dole__leave__button"},[_c('div',{staticClass:"levo__dole__leave__button--img"})])
}]

export { render, staticRenderFns }